import React, { Component } from 'react'
import { Switch } from 'react-router-dom/cjs/react-router-dom';
import { Route } from 'react-router-dom/cjs/react-router-dom.min';
import HealthCoachDashbord from '../../components/HealthCoach/HealthCoachDashboard';

class HealthCoach extends Component {

  constructor(){
    super();
  }


  healthCoachDashboard = () => {
    window.console.log("hii")
    return <HealthCoachDashbord/>;
  }
  
  render(){
    return (
      <>
        <Switch>
          <Route path="/health-coach/dashboard" exact render={this.healthCoachDashboard}></Route>
        </Switch>
      </>
    )
  } 
}

export default HealthCoach;
